import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-md py-4' : 'bg-transparent py-6'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 cursor-pointer">
          <div className="w-10 h-10 bg-[#39FF14] rounded-lg flex items-center justify-center">
            <span className="text-black font-bold text-xl">EI</span>
          </div>
          <span className={`font-bold text-lg whitespace-nowrap ${scrolled ? 'text-black' : 'text-white'}`}>
            Entrenamiento Inteligente
          </span>
        </Link>

        <div className="flex items-center gap-6">
          <Link
            to="/"
            className={`font-medium transition-colors whitespace-nowrap cursor-pointer ${
              scrolled ? 'text-gray-700 hover:text-[#1A3A2E]' : 'text-white hover:text-[#39FF14]'
            }`}
          >
            Inicio
          </Link>
          <Link
            to="/#modulos"
            className={`font-medium transition-colors whitespace-nowrap cursor-pointer ${
              scrolled ? 'text-gray-700 hover:text-[#1A3A2E]' : 'text-white hover:text-[#39FF14]'
            }`}
          >
            Todos los Módulos
          </Link>
          <button className="bg-[#39FF14] text-black px-6 py-3 rounded-full font-medium hover:bg-[#2EE000] transition-colors whitespace-nowrap cursor-pointer">
            Inscribirme
          </button>
        </div>
      </div>
    </nav>
  );
}